const Roles = {
    Admin: 'admin',
    User: 'user'
}

export default Roles;